<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-cutoff-type-dialog-create
          v-if="$hasPermissionTo(['create cut off types'])"
          @created="loadCutoffTypes"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Cutoff Type's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in cutoff type here"
          append-icon="search"
          label="Search Cutoff Type"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredCutoffTypes"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.description="{ item }">
        <div v-html="item.description" />
      </template>
      
      <template v-slot:item.action=" {item }">
        <span v-if="statusFilter">
          <setup-payroll-cutoff-type-dialog-edit
            v-if="$hasPermissionTo(['update cut off types'])"
            :cutoff-type="item"
            @updated="refreshData"
          />
          <span class="mx-1" />
          <setup-payroll-cutoff-type-dialog-delete
            v-if="$hasPermissionTo(['delete cut off types']) && $vuetify.breakpoint.mdAndUp"
            :cutoff-type="item"
            @deleted="refreshData"
          />
          <setup-payroll-cutoff-type-dialog-delete-mobile
            v-if="$hasPermissionTo(['delete cut off types']) && $vuetify.breakpoint.smAndDown"
            :cutoff-type="item"
            @deleted="refreshData"
          />
        </span>
        <span v-else>
          <setup-payroll-cutoff-type-dialog-restore
            v-if="$hasPermissionTo(['restore cut off types']) && $vuetify.breakpoint.mdAndUp"
            :cutoff-type="item"
            @restored="refreshData"
          />
          <setup-payroll-cutoff-type-dialog-restore-mobile
            v-if="$hasPermissionTo(['restore cut off types']) && $vuetify.breakpoint.smAndDown"
            :cutoff-type="item"
            @restored="refreshData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollCutoffTypeDialogCreate: () => import('@/components/hris/setup/payroll/cutoff-type/DialogCreate'),
      SetupPayrollCutoffTypeDialogEdit: () => import('@/components/hris/setup/payroll/cutoff-type/DialogEdit'),
      SetupPayrollCutoffTypeDialogDelete: () => import('@/components/hris/setup/payroll/cutoff-type/DialogDelete'),
      SetupPayrollCutoffTypeDialogDeleteMobile: () => import('@/components/hris/setup/payroll/cutoff-type/DialogDeleteMobile'),
      SetupPayrollCutoffTypeDialogRestore: () => import('@/components/hris/setup/payroll/cutoff-type/DialogRestore'),
      SetupPayrollCutoffTypeDialogRestoreMobile: () => import('@/components/hris/setup/payroll/cutoff-type/DialogRestoreMobile'),
    },
    data () {
      return {
        cutoffTypes: [],
        trashedCutoffTypes: [],
        headers: [
          {
            text: 'Code',
            align: 'left',
            value: 'code',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: 'Start Period',
            align: 'left',
            value: 'start_period',  
          },
          {
            text: 'Start Day',
            align: 'left',
            value: 'start_day',  
          },
          {
            text: 'End Period',
            align: 'left',
            value: 'end_period',  
          },
          {
            text: 'End Day',
            align: 'left',
            value: 'end_day',  
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: false,
      }
    },
    computed: {
      filteredCutoffTypes () {
        return this.statusFilter ? this.cutoffTypes : this.trashedCutoffTypes
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadCutoffTypes () {
        this.tableLoading = true

        this.$api.cutoffTypes().list()
          .then(response => {
            this.cutoffTypes = _.orderBy(response.data, ['code'], ['asc'])

            this.tableLoading = false
          })
      },
      loadTrashedCutoffTypes () {
        this.$api.cutoffTypes().listTrashed()
          .then(response => {
            this.trashedCutoffTypes = _.orderBy(response.data, ['code'], ['asc'])
          })
      },
      refreshData () {
        this.loadCutoffTypes()
        this.loadTrashedCutoffTypes()
      },
    },
  }
</script>

<style scoped>
.font-calibri{
    font-family: Calibri !important;
}

.font-16{
    font-size:16px;
}

.border-bottom-light-grey{
    border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
    max-height: 36px !important;
}

.border{
    border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
    padding-left:0px
}

.strike-through{
  text-decoration: line-through;
}
</style>
